@if (employeeId()) {
  <button
    type="button"
    tabindex="-1"
    class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center text-text-muted hover:text-text-primary transition-colors cursor-pointer"
    aria-label="Mitarbeiter anzeigen"
    (click)="popover.toggle($event)"
  >
    <span class="material-icons text-lg">info</span>
  </button>
}

<p-popover #popover appendTo="body" styleClass="employee-info-popover-panel-style" (onShow)="onShow()">
  <span class="text-sm text-text-primary whitespace-nowrap">{{ loading() ? 'Lädt…' : text() }}</span>
</p-popover>
